import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductionCalendarService = {
  async getProductionProcess() {
    const requestScreenData = {
      url: "api/Process",
      filter: `IsCriticalProcess eq 'Y' and Inactive eq 'N'`,
      select: "Code, Description ,Inactive, IsCriticalProcess",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getScheduleNote(recordId) {
    const requestScreenData = {
      url: "api/ProductionScheduleNote",
      filter: `RecordId eq ${recordId}`,
      expand: "ProductionScheduleNoteProcesses",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkHours(startDate, endDate, ProcessCode) {
    const requestScreenData = {
      url: "api/ProcessCalendarPreview",
      filter: `ShiftDateStart ge ${startDate} and ShiftDateStart le ${endDate}`,
      // select: 'Date, StartTime, EndTime'
      orderby: "ShiftDateStart asc",
    };

    if (ProcessCode) {
      requestScreenData.filter += ` and ProcessCode eq '${ProcessCode}'`;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getPlanTiles(branchCode, processCodes, startDate, endDateExclusive, filterValues) {
    // Date basis is StartDate (earliest shift allocation start date per
    // WorkOrderCode+ProcessCode, resolved server-side) — not PackDate
    // (completion date). Task 73071.
    let filter = `(BranchCode eq '${branchCode}') and (FriendlyStatus ne 'Cancelled') and (StartDate ge ${startDate} and StartDate lt ${endDateExclusive})`;

    if (processCodes && processCodes.length > 0) {
      const processFilter = processCodes
        .map((code) => `ProcessCode eq '${code}'`)
        .join(" or ");
      filter += ` and (${processFilter})`;
    }

    if (filterValues) {
      filter += ` and (${filterValues})`;
    }

    const requestScreenData = {
      url: "api/ProductionScheduleWorkOrderToSalesOrderLine",
      filter,
      select:
        "RecordId, WorkOrderCode, WorkOrderSequence, Position, WOType, ProcessCode, ProductCode, ProductDescription1, CustomerName, SalesOrderCode, SalesOrderStockUMQuantity, StockUM, FriendlyStatus, StartDate, EndDate, BranchCode, HasNote, CustomerMarketCode, ProductAttribute07Code",
      orderby: "StartDate asc, WorkOrderSequence asc, Position asc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async saveScheduleNote(scheduleNote) {
    const url = "api/ProductionScheduleNote/Notes";

    return await ApiService.post(url, scheduleNote);
  },

  async shiftAllocationResize(payload) {
    const url = "api/ShiftAllocationResize";

    return await ApiService.post(url, payload);
  },
};

export { ProductionCalendarService };
